import { classNames } from "@punks/ui-core"
import { useLocale } from "@/modules/navigation"
import { useLocaleContext } from "@/modules/i18n/context"

type Language = {
  code: string
  name: string
  emoji: string
}

const LANGUAGES: Language[] = [
  { code: "en", name: "English", emoji: "🇬🇧" },
  { code: "it", name: "Italiano", emoji: "🇮🇹" },
  {
    code: "fr",
    name: "Français",
    emoji: "🇫🇷",
  },
]

export type LanguageListProps = {
  languages?: Language[]
}

export const LanguageList: React.FC<LanguageListProps> = ({
  languages = LANGUAGES,
}) => {
  const { changeLocale, locale } = useLocale()

  return (
    <div
      className={classNames(
        "absolute right-[-8px] bottom-[-100%]",
        "bg-white text-black py-2 px-3 shadow-xl rounded-sm z-50"
      )}
    >
      <ul className="space-y-1.5">
        {languages.map(({ code, name, emoji }) => (
          <li key={code}>
            <button
              type="button"
              onClick={() => changeLocale(code)}
              className={classNames(
                locale === code && "font-bold",
                "whitespace-nowrap px-1 py-1.5 flex items-center space-x-2"
              )}
            >
              <span>{emoji}</span>
              <span>{name.toUpperCase()}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}
